/**
 * Retorna o termo de exibição para recebíveis conforme o tipo da empresa.
 * Para academia: "Mensalidade(s)"; para os demais: "Título(s)".
 *
 * @param {string} [companyType] - Tipo da empresa (ex.: 'academia', 'isp', 'empresa')
 * @returns {{ singular: string, plural: string, pluralLower: string, receivedLabel: string, pendingLabel: string, issuedLabel: string, valueInLabel: string, paidLabel: string }}
 */
export function getReceivableTerm(companyType) {
  if (companyType === 'academia') {
    return {
      singular: 'Mensalidade',
      plural: 'Mensalidades',
      pluralLower: 'mensalidades',
      receivedLabel: 'Mensalidades Recebidas',
      pendingLabel: 'Mensalidades Pendentes',
      issuedLabel: 'Mensalidades Emitidas',
      valueInLabel: 'Valor em mensalidades',
      paidLabel: 'Mensalidades pagas',
      percentualRecebidosSubtitle: 'Percentual de mensalidades recebidas',
      newButtonLabel: 'Nova Mensalidade'
    };
  }
  return {
    singular: 'Título',
    plural: 'Títulos',
    pluralLower: 'títulos',
    receivedLabel: 'Títulos Recebidos',
    pendingLabel: 'Títulos Pendentes',
    issuedLabel: 'Títulos Emitidos',
    valueInLabel: 'Valor em títulos',
    paidLabel: 'Títulos pagos',
    percentualRecebidosSubtitle: 'Percentual de títulos recebidos',
    newButtonLabel: 'Novo Título'
  };
}
